module.exports = __webpack_public_path__ + "static/media/seun-bio.fb4408a1.jpeg";